var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdultsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03655 4.10714C9.03655 2.97275 8.57655 1.94596 7.83398 1.20339C7.09059 0.46 6.0638 0 4.92941 0C3.79502 0 2.76823 0.46 2.02484 1.20339C1.28227 1.94596 0.822266 2.97275 0.822266 4.10714C0.822266 5.24154 1.28227 6.26832 2.02484 7.01089C2.76823 7.75429 3.79502 8.21429 4.92941 8.21429C6.0638 8.21429 7.09059 7.75429 7.83398 7.01089C8.57655 6.26832 9.03655 5.24154 9.03655 4.10714Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.3218C0 13.1433 1.84821 13.9647 4.92857 13.9647C7.81836 13.9647 9.85714 13.1433 9.85714 12.3218C9.85714 10.679 7.9235 9.03613 4.92857 9.03613C1.84821 9.03613 0 10.679 0 12.3218Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdultsIcon);
export default __webpack_public_path__ + "static/media/adults-icon.73576aeeea07ce764bbaec8f25627eef.svg";
export { ForwardRef as ReactComponent };